// import React from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { Row, Col } from "react-bootstrap";
// import socket from "../../../../Socket";
// import storage from "../../../../Storage";
// import { __, Event, encode } from "../../../../Helper";
// import C from "../../../../Constant";
// import Gif from "./Gif";
// import { WiRaindrops } from "react-icons/wi";
// import { SiSlashdot } from "react-icons/si";
// import { CiBitcoin } from "react-icons/ci";
// import { BsEmojiSmile } from "react-icons/bs";
// import EmojiPicker from 'emoji-picker-react';
// import { MdAdd } from "react-icons/md";
// import { fontWeight, width } from "@mui/system";

// class Submit extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             message: '',
//             isLogged: storage.getKey('logged') !== null,
//             country: "GLOBAL",
//             showEmojiPicker: false,
//             showChatBottom: false, // New state for dropdown
//         };
//     }

//     // Toggle chat dropdown visibility
//     toggleChatBottom = () => {
//         this.setState(prevState => ({
//             showChatBottom: !prevState.showChatBottom
//         }));
//     };

//     handleChange = (e) => {
//         const { name, value } = e.target;
//         this.setState({ [name]: value });
//     };

//     submit = (e) => {
//         e.preventDefault();
//         if (this.state.message.trim() === '') return;

//         socket.emit(C.ADD_CHAT, { message: this.state.message, country: this.state.country });
//         this.setState({ message: '' });
//         Event.emit('scrolldone');
//     };

//     handleSubmit = (e) => {
//         if (e.which === 13) {
//             this.submit(e);
//         }
//     };

//     toggleEmojiPicker = () => {
//         this.setState(prevState => ({ showEmojiPicker: !prevState.showEmojiPicker }));
//     };

//     onEmojiClick = (emojiData) => {
//         this.setState(prevState => ({
//             message: prevState.message + emojiData.emoji, 
//             showEmojiPicker: false 
//         }));
//     };

//     render() {
//         const { t } = this.props;
//         const style = {
//             right: 20,
//             fontWeight: "600",
//         };

//         return (
//             <>
//                 {/* <div className="chat-input">
//                     <form onKeyPress={this.handleSubmit}>
//                         <div className="form-group mb-0 bordering">
//                             <div className="input-group">
//                                 {this.state.isLogged ? (
//                                     <>
//                                         <textarea
//                                             style={style}
//                                             onChange={this.handleChange}
//                                             autoComplete="off"
//                                             name="message"
//                                             className="form-control textarea-new"
//                                             placeholder={t('Your Message')}
//                                             value={this.state.message}
//                                         />
//                                         <BsEmojiSmile className="emoji-area" fontSize="20px" onClick={this.toggleEmojiPicker} style={{ cursor: 'pointer' }} />
//                                         {this.state.showEmojiPicker && (
//                                             <div className="emoji-picker">
//                                                 <EmojiPicker style={{ background: "#17181B", border: "transparent" }} height={300} width={300} onEmojiClick={this.onEmojiClick} />
//                                             </div>
//                                         )}
//                                     </>
//                                 ) : (
//                                     <textarea
//                                         style={style}
//                                         disabled
//                                         autoComplete="off"
//                                         className="form-control"
//                                         placeholder={t('Your Message')}
//                                         value={t('please_login_to_use_chat')}
//                                     />
//                                 )}
//                                 <button
//                                     className="btn btn-toggle-chat"
//                                     onClick={this.toggleChatBottom}
//                                     type="button"
//                                     style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         position: "absolute",
//                                         right: "10px",
//                                         top: "50%",
//                                         transform: "translateY(-50%)"
//                                     }}
//                                 >
//                                     <WiRaindrops fontSize="30px" />
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </div>

          
//                 <div
//                     className={`chat-bottom-dropdown ${this.state.showChatBottom ? 'open' : ''}`}
//                     style={{
//                         display: this.state.showChatBottom ? 'block' : 'none',
//                         position: 'absolute',
//                         bottom: 0,
//                         left: 0,
//                         width: '100%',
//                         backgroundColor: '#222',
//                         padding: '15px',
//                         borderTopLeftRadius: '15px',
//                         borderTopRightRadius: '15px',
//                         boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
//                         zIndex: 1000,
//                         transition: 'transform 0.3s ease',
//                     }}
//                 >
//                     <div className="chat-bottom">
//                         <div className="d-flex justify-content-around">
//                             <button className="btn btn-bldock btn-xs" onClick={this.submit}>
//                                 <WiRaindrops fontSize="40px" />
//                             </button>
//                             <button className="btn btn-send-chat btn-bldock btn-xs" disabled>
//                                 <SiSlashdot fontSize="20px" />
//                             </button>
//                             <button className="btn btn-send-chat btn-bldock btn-xs" disabled>
//                                 <CiBitcoin fontSize="30px" />
//                             </button>
//                         </div>
//                         <Gif />
//                     </div>
//                 </div> */}
// <div className={`chat-container ${this.state.showChatBottom ? 'dropdown-open' : ''}`}>
//     {/* Search Bar */}
//     <div className="chat-input-wrapper">
//         <div className="chat-input" >
//             <form onKeyPress={this.handleSubmit}>
//                 <div className="form-group mb-0 bordering" style={{backgroundColor:"rgb(50, 55, 56)",padding:"8px 5px",display:"flex",flexDirection:"row",alignItems:"center",gap:"0px"}}>
//                     <div style={{display:'flex',alignItems:"center"}}  className="input-group">
//                         {this.state.isLogged ? (
//                             <>
//                                 <textarea
//                                     style={style}
//                                     onChange={this.handleChange}
//                                     autoComplete="off"
//                                     name="message"
//                                     className="form-control textarea-new"
//                                     placeholder={t('Your Message...')}
//                                     value={this.state.message}
//                                 />
//                                 <div className="emoji-area">
//                                    <Gif/>
//                                 <BsEmojiSmile
//                                     fontSize="18px"
//                                     onClick={this.toggleEmojiPicker}
//                                     style={{ cursor: 'pointer',margin:"0px 5px" ,color:"white"}}
//                                 />
//                                 {this.state.showEmojiPicker && (
//                                     <div className="emoji-picker">
//                                         <EmojiPicker
//                                             style={{ background: "#17181B", border: "transparent" }}
//                                             height={300}
//                                             width={300}
//                                             onEmojiClick={this.onEmojiClick}
//                                         />
//                                     </div>
//                                 )} 
//                                 </div>
//                             </>
//                         ) : (
//                             <>
//                             <textarea
//                                 style={style}
//                                 disabled
//                                 autoComplete="off"
//                                 className="form-control"
//                                 placeholder={t('Your Message')}
//                                 value={t('please_login_to_use_chat')}
//                             />
//                             <div className="emoji-area">
//                                    <Gif/>
//                                 <BsEmojiSmile
//                                     fontSize="18px"
//                                     onClick={this.toggleEmojiPicker}
//                                     style={{ cursor: 'pointer',margin:"0px 5px" ,color:"white"}}
//                                 />
//                                 {this.state.showEmojiPicker && (
//                                     <div className="emoji-picker">
//                                         <EmojiPicker
//                                             style={{ background: "#17181B", border: "transparent" }}
//                                             height={300}
//                                             width={300}
//                                             onEmojiClick={this.onEmojiClick}
//                                         />
//                                     </div>
//                                 )} 
//                                 </div>
//                             </>
//                         )}
               
//                     </div>
//                     <button
//                             className="btn btn-toggle-chat"
//                             onClick={this.toggleChatBottom}
//                             type="button"
//                             style={{
//                                 background: " rgb(20, 180, 151)",
//                                 border: "none",
//                                 cursor: "pointer",
//                                 height:"6.5vh"
//                                 // margin:"0px 5px",
//                                 // position: "absolute",
//                             }}
//                         >
//                             <MdAdd fontSize="25px" color="black" />
//                         </button>
//                 </div>
//             </form>
//         </div>
//     </div>

//     {/* Chat Bottom Dropdown */}
//     <div
//         className={`chat-bottom-dropdown ${this.state.showChatBottom ? 'open' : ''}`}
//         style={{
//             display: this.state.showChatBottom ? 'block' : 'none',
//             position: 'absolute',
//             bottom: 0,
//             left: 0,
//             margin:"0px 1px",
//             width: '100%',
//             backgroundColor: '#000',
//             padding: '5px',
//             // borderTopLeftRadius: '15px',
//             // borderTopRightRadius: '15px',
//             boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
//             zIndex: 1000,
//             transition: 'transform 0.3s ease',
//         }}
//     >
//         <div className="chat-bottom">
//             <div className="d-flex justify-content-around">
//                 <button className="btn " style={{ background: "#3D4445",margin:"4px",width:"40px",height:"40px",borderRadius:"7px",border:"1px solid #14b497",color:"white"}} onClick={this.submit}>
//                     <WiRaindrops fontSize="30px"/>
//                 </button>
//                 <button className="btn btn-send-chat btn-bldock  btn-xs"  style={{ background: "#3D4445",margin:"4px",width:"40px",height:"40px",borderRadius:"7px",border:"1px solid #14b497",color:"white"}}>
//                     <SiSlashdot fontSize="20px" />
//                 </button>
//                 <button className="btn btn-send-chat btn-bldock btn-xs" style={{ background: "#3D4445",margin:"4px",width:"40px",height:"40px",borderRadius:"7px",border:"1px solid #14b497",color:"white"}}>
//                     <CiBitcoin fontSize="30px" />
//                 </button>
//             </div>
           
            
//         </div>
//     </div>
// </div>

//             </>
//         );
//     }
// }

// Submit.propTypes = {
//     name: PropTypes.string,
//     country: PropTypes.string,
//     gif: PropTypes.string
// };

// const mapStateToProps = state => ({
//     name: state.items.name,
//     country: state.items.country,
//     gif: state.items.gif
// });

// export default connect(mapStateToProps, {})(Submit);













import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { WiRaindrops } from "react-icons/wi";
import { SiSlashdot } from "react-icons/si";
import { CiBitcoin } from "react-icons/ci";
import { BsEmojiSmile } from "react-icons/bs";
import EmojiPicker from 'emoji-picker-react';
import { MdAdd, MdSend } from "react-icons/md";
import Gif from "./Gif";
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import { Event } from "../../../../Helper";
import C from "../../../../Constant";

class Submit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            isLogged: storage.getKey('logged') !== null,
            country: "GLOBAL",
            showEmojiPicker: false,
            showChatBottom: false,
            isTextareaActive: false,
        };
    }

    // Toggle chat dropdown visibility
    toggleChatBottom = () => {
        this.setState(prevState => ({
            showChatBottom: !prevState.showChatBottom
        }));
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    submit = (e) => {
        e.preventDefault();
        if (this.state.message.trim() === '') return;

        socket.emit(C.ADD_CHAT, { message: this.state.message, country: this.state.country });
        this.setState({ message: '', isTextareaActive: false });
        Event.emit('scrolldone');
    };

    handleSubmit = (e) => {
        if (e.which === 13) {
            this.submit(e);
        }
    };

    toggleEmojiPicker = () => {
        this.setState(prevState => ({ showEmojiPicker: !prevState.showEmojiPicker }));
    };

    onEmojiClick = (emojiData) => {
        this.setState(prevState => ({
            message: prevState.message + emojiData.emoji,
            showEmojiPicker: false
        }));
    };

    handleTextareaFocus = () => {
        this.setState({ isTextareaActive: true });
    };

    handleTextareaBlur = () => {
        if (this.state.message.trim() === '') {
            this.setState({ isTextareaActive: false });
        }
    };

    render() {
        const { t } = this.props;
        const style = {
            right: 20,
            fontWeight: "500",
        };

        return (
            <div className={`chat-container ${this.state.showChatBottom ? 'dropdown-open' : ''}`}>
                <div className="chat-input-wrapper">
                    <div className="chat-input">
                        <form onKeyPress={this.handleSubmit}>
                            <div className="form-group mb-0 bordering" style={{
                                backgroundColor: "rgb(50, 55, 56)",
                                padding: "8px 5px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0px"
                            }}>
                                <div style={{ display: 'flex', alignItems: "center" }} className="input-group">
                                    {this.state.isLogged ? (
                                        <>
                                            <textarea
                                                style={style}
                                                onChange={this.handleChange}
                                                autoComplete="off"
                                                name="message"
                                                className="form-control textarea-new"
                                                placeholder={t('Your Message...')}
                                                value={this.state.message}
                                                onFocus={this.handleTextareaFocus}
                                                onBlur={this.handleTextareaBlur}
                                            />
                                            <div className="emoji-area">
                                                <Gif />
                                                <BsEmojiSmile
                                                    fontSize="18px"
                                                    onClick={this.toggleEmojiPicker}
                                                    style={{ cursor: 'pointer', margin: "0px 5px", color: "white" }}
                                                />
                                                {this.state.showEmojiPicker && (
                                                    <div className="emoji-picker">
                                                        <EmojiPicker
                                                            style={{ background: "#17181B", border: "transparent" }}
                                                            height={300}
                                                            width={300}
                                                            onEmojiClick={this.onEmojiClick}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <textarea
                                                style={style}
                                                disabled
                                                autoComplete="off"
                                                className="form-control textarea-new"
                                                placeholder={t('Your Message')}
                                                value={t('please_login_to_use_chat')}
                                            />
                                           
                                        </>
                                    )}
                                </div>
                                <button
                                    className="btn btn-toggle-chat"
                                    onClick={this.state.isTextareaActive ? this.submit : this.toggleChatBottom}
                                    type="button"
                                    style={{
                                        background: this.state.isTextareaActive ? " rgb(46 213 91)" : "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        height: "6.5vh"
                                    }}
                                >
                                    {this.state.isTextareaActive ? (
                                        <MdSend fontSize="22px" color="black" />
                                    ) : (
                                        <MdAdd fontSize="22px" color="white" />
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className={`chat-bottom-dropdown ${this.state.showChatBottom ? 'open' : ''}`}
                    style={{
                        display: this.state.showChatBottom ? 'block' : 'none',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        margin: "0px 1px",
                        width: '100%',
                        backgroundColor: '#000',
                        padding: '5px',
                        boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 1000,
                        transition: 'transform 0.3s ease',
                    }}
                >
                    <div className="chat-bottom">
                        <div className="d-flex justify-content-around">
                            <button className="btn " style={{ background: "#3D4445", margin: "4px", width: "40px", height: "40px", borderRadius: "7px", border: "1px solid  rgb(46 213 91)", color: "white" }} onClick={this.submit}>
                                <WiRaindrops fontSize="30px" />
                            </button>
                            <button className="btn btn-send-chat btn-bldock  btn-xs" style={{ background: "#3D4445", margin: "4px", width: "40px", height: "40px", borderRadius: "7px", border: "1px solid rgb(46 213 91)", color: "white" }}>
                                <SiSlashdot fontSize="20px" />
                            </button>
                            <button className="btn btn-send-chat btn-bldock btn-xs" style={{ background: "#3D4445", margin: "4px", width: "40px", height: "40px", borderRadius: "7px", border: "1px solid rgb(46 213 91)", color: "white" }}>
                                <CiBitcoin fontSize="30px" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Submit.propTypes = {
    name: PropTypes.string,
    country: PropTypes.string,
    gif: PropTypes.string
};

const mapStateToProps = state => ({
    name: state.items.name,
    country: state.items.country,
    gif: state.items.gif
});

export default connect(mapStateToProps, {})(Submit);

